
import './AddressInputField.css';

const AddressInputField = ({
    title, 
    street, 
    setStreet, 
    city, 
    setCity, 
    state, 
    setState, 
    zip, 
    setZip,
    country = null,
    setCountry = null,
    countryList = null,
    countryComplete = null,
    locked,
    searchCustomer,
    streetComplete = null,
    cityComplete = null,
    stateComplete = null,
    zipComplete = null
}) => {
    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            if(searchCustomer) searchCustomer();
        }
    };

    // Helper function to get validation class
    const getValidationClass = (complete) => {
        if (complete === null) return '';
        if (complete === false) return 'incomplete';
        if (complete === true) return 'complete';
        return '';
    };

    // Helper function to get validation indicator
    const getValidationIndicator = (complete, fieldName) => {
        if (complete === null) return null;
        if (complete === false) return <span className='required-indicator'>*</span>;
        if (complete === true) return <span className='success-indicator'>✓</span>;
        return null;
    };

    return(
        <div className='address-input-field-container'>
            <div className='address-input-field-title'>
                {title}:
            </div>
            <div className='address-input-field-grid'>
                <div className='address-input-field-row'>
                    <div className='address-input-field-item'>
                        <label className='address-input-field-label'>
                            Street {getValidationIndicator(streetComplete, 'Street')}
                        </label>
                        <input 
                            className={`address-input-field-input ${getValidationClass(streetComplete)}`}
                            placeholder='Enter street address'
                            value={street} 
                            onChange={e => setStreet(e.target.value)} 
                            onKeyDown={e => handleKeyDown(e)}
                            disabled={locked}
                        />
                    </div>
                </div>
                <div className='address-input-field-row'>
                    <div className='address-input-field-item city-item'>
                        <label className='address-input-field-label'>
                            City {getValidationIndicator(cityComplete, 'City')}
                        </label>
                        <input 
                            className={`address-input-field-input ${getValidationClass(cityComplete)}`}
                            placeholder='Enter city'
                            value={city} 
                            onChange={e => setCity(e.target.value)} 
                            onKeyDown={e => handleKeyDown(e)}
                            disabled={locked}
                        />
                    </div>
                    <div className='address-input-field-item state-item'>
                        <label className='address-input-field-label'>
                            State/Province {getValidationIndicator(stateComplete, 'State/Province')}
                        </label>
                        <input 
                            className={`address-input-field-input ${getValidationClass(stateComplete)}`}
                            maxLength={2}
                            placeholder='ST'
                            value={state} 
                            onChange={e => setState(e.target.value.toUpperCase())} 
                            onKeyDown={e => handleKeyDown(e)}
                            disabled={locked}
                        />
                    </div>
                    <div className='address-input-field-item zip-item'>
                        <label className='address-input-field-label'>
                            ZIP {getValidationIndicator(zipComplete, 'ZIP')}
                        </label>
                        <input 
                            className={`address-input-field-input ${getValidationClass(zipComplete)}`}
                            maxLength={10}
                            placeholder='12345'
                            value={zip} 
                            onChange={e => setZip(e.target.value.toUpperCase())} 
                            onKeyDown={e => handleKeyDown(e)}
                            disabled={locked}
                        />
                    </div>
                    
                    {/* Country field - include in same row if country props are provided */}
                    {(country !== null || setCountry !== null) && (
                        <div className='address-input-field-item country-item'>
                            <label className='address-input-field-label'>
                                Country {getValidationIndicator(countryComplete, 'Country')}
                            </label>
                            {countryList && countryList.length > 0 ? (
                                <select 
                                    className={`address-input-field-select ${getValidationClass(countryComplete)}`}
                                    value={country || ''} 
                                    onChange={e => setCountry && setCountry(e.target.value)}
                                    disabled={locked}
                                >
                                    <option value="">Select Country</option>
                                    {countryList.map((countryOption, index) => (
                                        <option key={index} value={countryOption.value || countryOption}>
                                            {countryOption.text || countryOption}
                                        </option>
                                    ))}
                                </select>
                            ) : (
                                <input 
                                    className={`address-input-field-input ${getValidationClass(countryComplete)}`}
                                    placeholder='Enter country'
                                    value={country || ''} 
                                    onChange={e => setCountry && setCountry(e.target.value)} 
                                    onKeyDown={e => handleKeyDown(e)}
                                    disabled={locked}
                                />
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
};

export default AddressInputField;